import 'bootstrap'
import * as bootstrap from 'bootstrap'
import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../css/footing-designer.css'

import './components/nav-bar/nav-bar-account-buttons-component.js'
import './components/account/sign-up-modal-component.js'
import './components/account/finish-upgrade-modal-component.js'
import './components/account/login-modal-component.js'
import './components/account/forgot-password-modal-component.js'
import './components/account/logout-modal-component.js'

import './components/main-ui/project-list-component.js'
import './components/main-ui/project-header-settings-component.js'

import './components/card-buttons/footing-button-component.js'
import './components/card-buttons/load-button-component.js'

import './components/design-dialogs/footing-dialog-component.js'
import './components/design-dialogs/load-dialog-component.js'

import './components/main-ui/steel-component.js'
import './components/main-ui/geometry-component.js'

import { initializeApp } from 'firebase/app'
import { getAuth, browserLocalPersistence } from 'firebase/auth'
import { getDatabase, ref, get, set, update, remove, child, push } from 'firebase/database'

import {loadStripe} from '@stripe/stripe-js';

import FootingDesign from './footing-design.js'
import * as footingDesignDrawing from './footing-design-drawing.js'

const firebaseConfig = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
}

initializeApp(firebaseConfig)

const auth = getAuth()

let footingDesign = new FootingDesign()

let isUpgraded = false

document.addEventListener('project-loaded', async () => {
  footingDesignDrawing.drawAllDiagrams(footingDesign)
  document.getElementById('project-title').innerHTML = footingDesign.title
  document.getElementById("project-title-header-settings-text-input").value = footingDesign.title
}, true)

document.addEventListener('company-name-changed', (event) => {
  document.getElementById("your-company-name").innerHTML = event.detail
  document.getElementById("company-name-header-settings-text-input").value = event.detail
}, true)

document.addEventListener('project-title-changed', (event) => {
  footingDesign.title = event.detail
  document.getElementById("project-title").innerHTML = event.detail
  document.getElementById("project-title-header-settings-text-input").value = event.detail
}, true)

document.addEventListener('load-project', async (event) => {
  const project = event.detail
  onLoadProjectClick(project.key)
}, true)

// project settings and file menu
document.getElementById('project-list-new-design').onclick = onNewProjectClick
document.getElementById('file-menu-new-file').onclick = onNewProjectClick
document.getElementById('file-menu-save-file').onclick = onSaveProjectClick
document.getElementById('file-menu-print-file').onclick = onPrintProject
document.getElementById('file-menu-delete-file').onclick = onDeleteProjectClick
document.getElementById('active-project-title-needs-saved').onclick = onSaveProjectClick

// dialog events
document.addEventListener('footing-conditions-dialog-update', (event) => {
  footingDesign.footingConditions.onUpdate(event.detail)
}, true)
document.addEventListener('load-dialog-update', (event) => {
  footingDesign.load.onUpdate(event.detail)
}, true)
document.addEventListener('steel-dialog-update', (event) => {
  footingDesign.steel.onUpdate(event.detail)
}, true)
document.addEventListener('geometry-dialog-update', (event) => {
  footingDesign.geometry.onUpdate(event.detail)
}, true)
document.addEventListener('steel-dialog-update', (event) => {
  footingDesign.steel.onUpdate(event.detail)
}, true)

// model events
document.addEventListener('footing-conditions-changed', async () => {
  // update footing conditions button
  const event = new CustomEvent('update-footing-conditions-button', { detail: footingDesign });
  document.dispatchEvent(event)
  footingDesign.updateDesign()
  footingDesignDrawing.drawAllDiagrams(footingDesign)
}, true)

document.addEventListener('load-changed', async () => {
  // update load button
  const event = new CustomEvent('update-load-button', { detail: footingDesign });
  document.dispatchEvent(event)
  footingDesign.updateDesign()
  footingDesignDrawing.drawAllDiagrams(footingDesign)
}, true)

document.addEventListener('geometry-changed', async () => {
  footingDesign.updateDesign()
  footingDesignDrawing.drawAllDiagrams(footingDesign)
}, true)

document.addEventListener('steel-changed', async () => {
  console.log('update drawing')
  footingDesign.updateDesign()
  footingDesignDrawing.drawAllDiagrams(footingDesign)
}, true)

footingDesign.updateDesign()
footingDesignDrawing.drawAllDiagrams(footingDesign)

var rtime = new Date(1, 1, 2e3, 12, 0, 0), 
timeout = !1, 
delta = 100; 

window.onresize = (() => { 
    rtime = new Date, 
    timeout === !1 && (timeout = !0, setTimeout(resizeend, delta)) 
})

function resizeend() {
  new Date - rtime < delta ? setTimeout(resizeend, delta) : (timeout = !1, resizeCanvasArea())
} 

function resizeCanvasArea() { 
  footingDesignDrawing.drawAllDiagrams(footingDesign)
} 

function initializeFirebaseAuth() {

  auth.setPersistence(browserLocalPersistence)

  auth.onAuthStateChanged(function(user) {
    if (user) {
      const event = new CustomEvent('customer-logged-in', {detail: user});
      document.dispatchEvent(event)
      checkStripeSubscriptionAndConfigure()
    } else {
      // clear project list and reset the project
      configureLoggedOut()
    }
  })
}

initializeStripe()

async function checkStripeSubscriptionAndConfigure() {
  auth.currentUser.getIdToken().then(function(token) {
    fetch('https://us-central1-webstructrual.cloudfunctions.net/checkSubscription', {
      method: 'POST', 
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
    }).then((response) => {
      if(response.ok) {
        configureLoggedInAndUpgraded()      
      } else {
        configureLoggedInButNeedsUpgrade()
      }
    }).catch( (error) => {
      console.error(error)
      // error -> assume not subscribed
      configureLoggedInButNeedsUpgrade()
    })
  })
}

function configureLoggedInAndUpgraded() {
  isUpgraded = true
  const event = new CustomEvent('customer-logged-in-and-upgraded');
  document.dispatchEvent(event)
  
  document.getElementById('upgrade-now-to-unlock').classList.add('d-none')
  document.getElementById('almost-done-row').classList.add('d-none')
  document.getElementById('results').classList.remove('hidden-print')

  getProjectsFromDatabaseAndUpdateProjectList()

  const dbRef = ref(getDatabase())
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((snapshot) => {
    if (snapshot.exists()) {
      if(snapshot.val().username) {
        document.getElementById('signed-in-as').innerHTML = snapshot.val().username
      } else if(snapshot.val().email) {
        document.getElementById('signed-in-as').innerHTML = snapshot.val().email
      }
      if(snapshot.val().companyName) {
        document.getElementById("your-company-name").innerHTML = snapshot.val().companyName
        document.getElementById("company-name-header-settings-text-input").value = snapshot.val().companyName
      }
    } else {
      console.log("No data available")
    }
  }).catch((error) => {
    console.error(error)
  })
}

function configureLoggedInButNeedsUpgrade() {
  const event = new CustomEvent('customer-logged-in-not-upgraded');
  document.dispatchEvent(event)  
  
  document.getElementById('upgrade-now-to-unlock').classList.add('d-none')
  document.getElementById('almost-done-row').classList.remove('d-none')

  const dbRef = ref(getDatabase())
  get(child(dbRef, `users/${auth.currentUser.uid}`)).then((snapshot) => {
    if (snapshot.exists()) {
      if(snapshot.val().username) {
        document.getElementById('signed-in-as').innerHTML = snapshot.val().username + '<i class="fa fa-fw fa-info-circle text-danger"></i>'
      }
    } else {
      console.log("No data available")
    }
  }).catch((error) => {
    console.error(error)
  })
}

function configureLoggedOut() {
  isUpgraded = false
  let event = new CustomEvent('customer-logged-out')
  document.dispatchEvent(event)
      
  document.getElementById('almost-done-row').classList.add('d-none')
  document.getElementById('upgrade-now-to-unlock').classList.remove('d-none')
  document.getElementById('results').classList.add('hidden-print')
  projects = []

  footingDesign = new FootingDesign()
  event = new CustomEvent('project-loaded', {detail: footingDesign})
  document.dispatchEvent(event)
}

initializeFirebaseAuth()

let projects = []

function featureGate() {
  if(auth.currentUser === null || !isUpgraded) {
    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-sign-up-form')).show()
    return true
  } else if(auth.current !== null && !isUpgraded) {
    bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-finish-upgrade')).show()
    return true
  }
  return false
}

function onNewProjectClick() {
  if(featureGate()) { return }
  if(footingDesign.dirty) {
    showProjectYesNoModal('New Footing Project', 'Current footing project not saved. Continue anyway?', newProject)
    return
  } 
  newProject()
}

function newProject() {
  const updates = {}
  projects.forEach(project => {
    if(project.isActive) {
      project.isActive = false 
      // save change to database
      updates[`/projects/${auth.currentUser.uid}/footing-designer/${project.key}/isActive`] = false
    } 
  })
  update(ref(getDatabase()), updates)
  // 
  footingDesign = new FootingDesign()
  footingDesign.isActive = true 
  projects.push(footingDesign)
  let event = new CustomEvent('project-loaded', { detail: footingDesign });
  document.dispatchEvent(event)
  event = new CustomEvent('projects-loaded', { detail: projects });
  document.dispatchEvent(event)
  showProjectToast('New project created.')
}

function onSaveProjectClick() {
  if(featureGate()) { return } 
  saveProject()
}


/**
 * Writes a project to the database. If project.key does not exist
 * we generate a new key. otherwise we use the key stored in the project.
 * returns a Promise<Void> to the updated collection
 * 
 **/
 function saveProject() { 
  const projectsRef = ref(getDatabase(), 'projects')
  // is this a new project
  if(footingDesign.key === null) {
    footingDesign.key = push(projectsRef).key
  }

  footingDesign.modifiedAt = Date.now()
  footingDesign.isActive = true
  footingDesign.save()

  const projectRef = child(projectsRef, `/${auth.currentUser.uid}/footing-designer/${footingDesign.key}`)
  set(projectRef, footingDesign.serialize()).then(() => {
    // TODO: we really only need to do this if the project was a new project
    // might be better to just add the newly saved project to the list of 
    // projects and avoid the database call here...
    projects = []
    getProjectsFromDatabaseAndUpdateProjectList()
    showProjectToast('Project saved.')
  })
}

function onPrintProject() {
  if(featureGate()) { return }
  window.print()
}

function onDeleteProjectClick() {
  if(featureGate()) { return }
  showProjectYesNoModal('Delete Footing Project', 'Delete this project?', deleteProject)
}

function deleteProject() {
  if(featureGate()) { return }
  // TODO: are you sure you want to delete this project?
  const projectsRef = ref(getDatabase(), 'projects')
  const projectRef = child(projectsRef, `/${auth.currentUser.uid}/footing-designer/${footingDesign.key}`)
  remove(projectRef, {}).then(() => {
    projects = []
    getProjectsFromDatabaseAndUpdateProjectList('Project deleted.')
  })
}

/**
 * Gets projects from the realtime database and updates the project list.
 * Sets the active project if one is not set otherwise it assumes the first
 * active project (isActive) it finds is the active one.
 * @returns {Object.Array<AnchorBoltAdapter>} 
 **/
function getProjectsFromDatabaseAndUpdateProjectList(toastMessage) {
  if(featureGate()) { return }
  const projectsRef = ref(getDatabase(), `projects/${auth.currentUser.uid}/footing-designer/`)
  get(projectsRef).then((snapshot) => {
    if(snapshot.exists()) {
      snapshot.forEach(function(childSnapshot) {
        let childData = childSnapshot.val()
        let footing = new FootingDesign()
        footing.deserialize(childData)
        projects.push(footing)
      })
    }

    let activeIndex = projects.findIndex(project => project.isActive === true)
    if(activeIndex < 0 && projects.length > 0) { 
      activeIndex = 0 
      projects[0].isActive = true
    }

    // handle case where user has not saved projects yet - this is probably a bug in the anchor designer too
    if(projects.length > 0) {
      let key = projects[activeIndex].key
      loadProject(key, toastMessage)
    } else {
      // remove the spinner
      document.getElementById('project-list').innerHTML = ''
      // tell app to update the UI
      const event = new CustomEvent('project-loaded', { detail: footingDesign });
      document.dispatchEvent(event)
    }
    
    //return projects
  }).catch(error => {
    console.log(error)
  })
}

function onLoadProjectClick(key) {
  if(featureGate()) { return }
  if(footingDesign.dirty) {
    showProjectYesNoModal('Load Footing Project', 'Current footing project not saved. Continue anyway?', () => loadProject(key, 'Project loaded.') )
    return
  } 
  loadProject(key, 'Project loaded.')
}
/**
 *
 **/

let firstLoad = true
function loadProject(key, toastMessage) {
  const updates = {}
  projects.forEach(project => {
    if((project.isActive === true || project.isActive === undefined) && project.key !== key) {
      project.isActive = false 
      // save change to database
      if(project.key !== undefined && project.key !== null) {
        updates[`/projects/${auth.currentUser.uid}/footing-designer/${project.key}/isActive`] = false
      }
    } else if(project.key === key) {
      project.isActive = true 
      // save change to database 
      if(project.key !== undefined && project.key !== null) {
        updates[`/projects/${auth.currentUser.uid}/footing-designer/${project.key}/isActive`] = true
      }
      footingDesign = project
      let event = new CustomEvent('project-loaded', { detail: footingDesign });
      document.dispatchEvent(event)
      if(!firstLoad && toastMessage) {
        showProjectToast(toastMessage)
      }
      firstLoad = false
      if(footingDesign.dirty) {
        document.getElementById('active-project-title-needs-saved').classList.remove('d-none')
      } else {
        document.getElementById('active-project-title-needs-saved').classList.add('d-none')
      }
    }
  })

  // update project list
  const event = new CustomEvent('projects-loaded', { detail: projects });
  document.dispatchEvent(event)
  update(ref(getDatabase()), updates)
}

async function initializeStripe() {
  //const STRIPE_API_KEY='pk_test_oTBdaj3DiPoh2GN2LRP6bgzS'
  const STRIPE_API_KEY='pk_live_2xaQxOvCEelcE2SQvmCtWQac'
  const stripe = await loadStripe(STRIPE_API_KEY);
  //const stripe = await loadStripe(process.env.STRIPE_API_KEY);
  let elements = stripe.elements();

  // Custom styling can be passed to options when creating an Element.
  var style = {
    base: {
      // Add your base input styles here. For example:
      fontSize: '20px',
      color: "#32325d",
    }
  };

  if (typeof elements === 'undefined') {
      console.error("unable to create Stripe Card in initializeStripe(). elements undefined")
      return;
  }
  
  // Create an instance of the card Element.
  var card = elements.create('card', {style: style});

  if (typeof card === 'undefined') {
      console.error("unable to create Stripe Card in initializeStripe(). card undefined")
      return;
  }

  // Add an instance of the card Element into the `card-element` <div>.
  card.mount('#card-element');

  card.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
          displayError.textContent = event.error.message;
      } else {
          displayError.textContent = '';
      }
  });

  // Create a token or display an error when the form is submitted.
  var form = document.getElementById('payment-form');
  form.addEventListener('click', function(event) {
      event.preventDefault();
      stripe.createToken(card).then(function(result) {
          if (result.error) {
              // Inform the customer that there was an error.
              var errorElement = document.getElementById('card-errors');
              errorElement.textContent = result.error.message;
              console.error(result.error.message);
          } else {
              // Send the token to your server.
              stripeTokenHandler(result.token);
              //console.log(result.token);
          }
      });
  });
}

function stripeTokenHandler(token) {
  document.getElementById('submit-payment-spinner').classList.remove('d-none')
  document.getElementById('submit-payment-button').disabled = true

  var form = document.getElementById('payment-form');
  var hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'stripeToken');
  hiddenInput.setAttribute('value', token.id);
  form.appendChild(hiddenInput);

  var user = auth.currentUser;
  var uid = user.uid;
  var email = user.email;
  var tok = token.id;
  var card = token.card.id;

  var dict = {uid: uid, email: email, token: tok, card: card};

  auth.currentUser.getIdToken().then(function(token) {
    fetch('https://us-central1-webstructrual.cloudfunctions.net/subscription', {
      method: 'POST', 
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(dict)
    }).then((response) => {
      //console.log(response.ok)
      document.getElementById('submit-payment-spinner').classList.add('d-none')
      document.getElementById('submit-payment-button').disabled = false
      document.getElementById('subscribe-response-error').classList.add('d-none')
      document.getElementById('subscribe-response-error').innerHTML = ''
      checkStripeSubscriptionAndConfigure()
    }).catch( (error) => {
      document.getElementById('submit-payment-spinner').classList.add('d-none')
      document.getElementById('submit-payment-button').disabled = false
      document.getElementById('subscribe-response-error').classList.remove('d-none')
      document.getElementById('subscribe-response-error').innerHTML = error
    })
  })
}

function showProjectYesNoModal(title, body, onYesHandler) {
  document.getElementById('project-yes-no-modal-yes-button').onclick = onYesHandler
  document.getElementById('project-yes-no-modal-title').innerHTML = title
  document.getElementById('project-yes-no-modal-body').innerHTML = body
  bootstrap.Modal.getOrCreateInstance(document.getElementById('project-yes-no-modal')).show()
}

function showProjectToast(body) {
  document.getElementById('project-toast-body').innerHTML = body
  bootstrap.Toast.getOrCreateInstance(document.getElementById('project-toast')).show()
}
